import {
  PermissionConfig,
  WidgetNames,
  WorkflowConfig,
  WorkflowPageConfig,
} from '@finxone-platform/shared/sys-config-types';

export const getV1_0_171ToV1_0_172 = (workflowConfig: WorkflowConfig) => {
  const oneToOneKeys = Object.keys(workflowConfig);
  const mappingObject = {};
  // Assign mappings to not modify this version upgrade
  oneToOneKeys.forEach((key) => {
    Object.assign(mappingObject, {
      [key]: key,
    });
  });
  return {
    ...mappingObject,
    // add new version number
    version: {
      key: 'version',
      transform: function () {
        return 'v1.0.172';
      },
    },
    permissionSections: {
      key: 'permissionSections',
      transform: function (permissionSection: PermissionConfig): PermissionConfig {
        const { roles, subscriptions } = permissionSection;
        //look for all the transaction history and exchange history widgets in all the zones the widget can be placed, as per zone-list-array.ts
        roles.forEach((item) => {
          const zones = item.zones;
          if (zones && typeof zones === 'object') {
            Object.entries(zones).forEach(([, zone]) => {
              if (zone) {
                const mobilePages = zone?.canvases?.subscription?.['default']?.mobile?.pages as
                  | WorkflowPageConfig[]
                  | undefined;

                const desktopPages = zone?.canvases?.subscription?.['default']?.desktop?.pages as
                  | WorkflowPageConfig[]
                  | undefined;

                const tabletPages = zone?.canvases?.subscription?.['default']?.tablet?.pages as
                  | WorkflowPageConfig[]
                  | undefined;
                if (mobilePages?.length) {
                  findActionButtonsAndRemoveAuthConfig(mobilePages);
                }
                if (desktopPages?.length) {
                  findActionButtonsAndRemoveAuthConfig(desktopPages);
                }
                if (tabletPages?.length) {
                  findActionButtonsAndRemoveAuthConfig(tabletPages);
                }
              }
            });
          }
        });
        return <PermissionConfig>{
          zones: permissionSection.zones,
          subscriptions,
          roles,
          projectForms: permissionSection.projectForms,
        };
      },
    },
  };
};

function findActionButtonsAndRemoveAuthConfig(pagesArray: WorkflowPageConfig[]) {
  // Removes authentication related properties from the action buttons widgetproperties if they exist
  for (const page of pagesArray) {
    if (!page) continue;
    page.widgets = page.widgets.map((widget) => {
      if (widget.name === WidgetNames.FORM_SUBMISSION_BUTTON) {
        const widgetProperties = widget.widgetConfiguration?.attributes?.widgetProperties;
        if (widgetProperties) {
          ['linkedToProjectAuthenticationOrder', 'requiresAuthentication', 'confirmationOrder'].forEach(
            (prop) => {
              if (prop in widgetProperties) {
                delete widgetProperties[prop];
              }
            },
          );
        }
      }
      return widget;
    });
  }
  return pagesArray;
}
